package com.arena_web.data.api

import com.arena_web.data.dto.FeedPageDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPost
import io.ktor.client.*

class FeedApi(private val client: HttpClient) {

    suspend fun getFeed(params: Map<String, String> = emptyMap()): ApiResponse<FeedPageDto> {
        return client.apiGet("v1/feed", params)
    }

    suspend fun likePost(postId: String, type: String): ApiResponse<Map<String, Boolean>> {
        return client.apiPost("v1/feed/$postId/like?type=$type")
    }
}
